import {
  ScrollToElement,
} from './scroll-to';
import {
  Lazyloading,
} from './lazyloading';
import {
  MenuAdjuster,
} from './menuadjust';
import {
  Slider,
} from './slider';
import {
  HistorieSlider,
} from './historieslider';
import {
  CookieManager,
} from './cookie';
import {
  ReferenzSuche,
} from './referenz-suche';
import { AnalyticsManager } from './analytics';
import { MapsManager } from './maps';

$(function () {
  const scrollTo = new ScrollToElement();
  const lazyLoading = new Lazyloading();
  const sliderKompetenz = new Slider('kompetenz--single__slider');
  const sliderStart = new Slider('start__referenzen__slider');
  const sliderReferenz = new Slider('referenz--single__slider');
  const historieSlider = new HistorieSlider();

  const navOpenObj = {
    navOpen: false,
  };

  // -------------------------------------------------------------
  // scrollTo
  scrollTo.scrolltoGlobalElement();
  scrollTo.scrolltoTopElement();

  // -------------------------------------------------------------
  // lazyLoading
  lazyLoading.init();

  // -------------------------------------------------------------
  // AdjustingMenu
  MenuAdjuster.init(navOpenObj);

  // -------------------------------------------------------------
  // Slider
  sliderKompetenz.init();
  sliderStart.init();
  sliderReferenz.init();
  historieSlider.init();

  // Cookies
  CookieManager.init();

  // Referenzsuche
  ReferenzSuche.init();

  // Analytics
  AnalyticsManager.checkCookies();

  // Maps
  MapsManager.checkCookies();


  var pathname = window.location.pathname;
  if (pathname.includes('stellenanzeigen')) {
    try {
      setTimeout(() => {
        const stellenanzeigenFile = $('#sjb-application-form > div.row .form-group  .file span')
        stellenanzeigenFile.text('Keine Datei ausgewählt');
        stellenanzeigenFile.addClass('stellenanzeigen__file');

        const stellenanzeigenBrowse = $('#sjb-application-form > div.row .form-group .file > div')
        stellenanzeigenBrowse.text('Auswählen');
        stellenanzeigenBrowse.addClass('stellenanzeigen__browse');

        const stellenanzeigenSuccess = $('#jobpost_form_status');
        const stellenanzeigenLoading = $('.sjb-loading');
        stellenanzeigenLoading.hide();


        stellenanzeigenSuccess.on('DOMSubtreeModified', function () {
          const success = stellenanzeigenSuccess.find('.alert.alert-success');
          if (!!success) {
            stellenanzeigenSuccess.off();
            success
              .text('Vielen Dank für Ihre Bewerbung. Wir hoffen Sie bald zu einem Vorstellungsgespräch einladen zu können.');
          }
        });
        $('#loader__wrapper').hide();
      }, 1000)
    } catch (e) {
    }
  } else {
    $('#loader__wrapper').hide();
  }
  if (pathname == '/') {
    setInterval(() => {
      toggleClass($('#meissen__bg'), 'start__intro__container__bg--active')
      toggleClass($('#hochablass__bg'), 'start__intro__container__bg--active')
    }, 5000)
  }

});


function toggleClass(item, cssClass) {
  if (item.hasClass(cssClass)) {
    item.removeClass(cssClass)
  } else {
    item.addClass(cssClass)
  }
}